import { http } from "../http/Http";
import { PartnerTypeFeaturesPermission } from "../models/PartnerTypeFeaturesPermission";
import { ServiceResponse } from "../models/ServiceResponse";

export class FeaturePermissionService {

    getAll = async (partnerTypeCode: string): Promise<ServiceResponse<PartnerTypeFeaturesPermission[]>> => {
        const { data } = await http.get<ServiceResponse<PartnerTypeFeaturesPermission[]>>("PartnerTypeFeaturesPermission/GetAll/" + partnerTypeCode);
        return data;
    };

    update = async (partnerTypeFeaturesPermission: PartnerTypeFeaturesPermission): Promise<ServiceResponse<PartnerTypeFeaturesPermission>> => {
        const { data } = await http.put<ServiceResponse<PartnerTypeFeaturesPermission>>("PartnerTypeFeaturesPermission/Put", partnerTypeFeaturesPermission);
        return data;
    };
}